import SlideFrame from "./_SlideFrame";

const executive = [
  {
    name: "Jason Nemeth",
    role: "Founder & CEO",
    bio: "Jason brings 16 years of experience building and scaling a full-stack retail installment platform. He pioneered the \"merchant-as-the-bank\" model — originating and servicing more than 60,000 contracts representing $227M+ in retail installment volume, and architecting the company's full origination, servicing, and payment infrastructure. BS, Industrial Engineering, Ohio Northern University.",
  },
  {
    name: "Jeff Briggs",
    role: "Chief Financial Officer",
    bio: "Jeff is a former NASA systems engineer who helped build components for the Perseverance Mars rover, now leading IBA's finance function with 15+ years of CFO experience. At Seagate Investment Company he led acquisitions that drove 4× revenue and 6× EBITDA growth, and through Briggs Growth Advisors he has supported 50+ early-stage tech companies through financial modeling and successful exits. MBA (Case Western Weatherhead), MS Plasma Physics (Dartmouth), BS Math & Physics (Centre College).",
  },
];

const operations = [
  {
    name: "Jamie Tann",
    role: "Chief Operating Officer",
    bio: "Jamie leads servicing operations at IBA with seven-plus years at Rocket Loans — most recently Senior Director of Operations — where she ran borrower identity verification, debt-settlement workflows, and operational project delivery at national scale. The operator behind IBA's top-decile on-time payment performance.",
  },
  {
    name: "Senga Rutebuka",
    role: "Head of Servicing Growth",
    bio: "Senga spent nearly a decade at Rocket Loans across operations, servicing, and senior business strategy. She now leads partner strategy and servicing growth for IBA — the bridge between how loans are boarded and how portfolios scale. Active fintech investor through Bias Capital and VU Venture Partners.",
  },
  {
    name: "Colin Darke",
    role: "General Counsel",
    bio: "Eight years as Chief Compliance Officer and General Counsel at Rocket Loans, where he built the consumer-lending compliance program end-to-end. Senior Advisor to the American Fintech Council. Licensed in Illinois, Michigan, and Massachusetts. LL.M., Banking & Financial Law, Boston University.",
  },
];

const customerSuccess = [
  {
    name: "Lisa Nemeth",
    role: "Customer Service Supervisor",
    bio: "Marine Corps veteran with 25+ years in high-volume customer service and billing operations. Has been with the company for over 13 years, leading call-center training, employee development, and day-to-day servicing performance. Builds disciplined, customer-focused teams that hold service quality consistent at scale. Daniel Webster University.",
  },
  {
    name: "Brian Helmbrecht",
    role: "Client Success Manager",
    bio: "Operations and client-success leader with 20+ years launching locations, building teams, and driving operational excellence. Has opened multiple franchise locations and led large-scale programs for national brands — managing hundreds of employees across training, development, and customer experience. Degree in Business Management.",
  },
];

const advisory = [
  {
    name: "Harjas Sidhu",
    role: "Advisor · Co-Founder, ForeSight Beacon AI",
    bio: "Senior financial-services executive with 20+ years building and scaling data-driven businesses across consumer lending, deposits, and payments. Formerly SVP at PNC Financial Services and strategy leader at Booz & Company. MBA, University of Chicago Booth.",
  },
  {
    name: "Taesun Cha",
    role: "Advisory Board",
    bio: "Cross-functional operator with 30+ years across accounting/finance, marketing, supply chain, strategy, M&A, and R&D at technology-driven industries. Prior leadership roles at TRW Inc., Ferro Corporation, and Kent Displays.",
  },
];

function Group({ label, people }) {
  const cols =
    people.length >= 4 ? "md:grid-cols-2 lg:grid-cols-4"
    : people.length === 3 ? "md:grid-cols-3"
    : people.length === 2 ? "md:grid-cols-2"
    : "md:grid-cols-1";
  return (
    <div>
      <p className="overline mb-6">{label}</p>
      <div className={`grid ${cols} gap-px bg-foreground/20 border border-foreground/20`}>
        {people.map((p) => (
          <article
            key={p.name}
            className="bg-background p-6 md:p-7 flex flex-col min-h-[280px]"
          >
            <header className="mb-4 border-b border-current/10 pb-3">
              <h3 className="font-display text-2xl tracking-tight leading-tight">{p.name}</h3>
              <p className="font-mono-data text-[11px] uppercase tracking-brand mt-1 text-muted-foreground">
                {p.role}
              </p>
            </header>
            <p className="text-sm leading-relaxed text-foreground/80">
              {p.bio}
            </p>
          </article>
        ))}
      </div>
    </div>
  );
}

export default function SlideLeadership() {
  return (
    <SlideFrame tag="01 · Who's Behind This">
      <div className="mb-10 max-w-5xl">
        <p className="overline mb-4">Team</p>
        <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.95] font-medium">
          A <em className="italic text-primary">trusted team</em>, not just a platform.
        </h2>
        <p className="mt-5 text-foreground/75 max-w-3xl leading-relaxed">
          Servicing is ultimately a people business. Our operating bench is built from best-in-class
          Rocket Loans talent — the servicing, legal, and growth leaders who ran a national consumer-lending
          program end-to-end — now assembling a scalable, best-of-market system for the next generation
          of lenders.
        </p>
      </div>

      <div className="space-y-10">
        <Group label="Executive Leadership" people={executive} />
        <Group label="Servicing · Growth · Legal (ex-Rocket Loans)" people={operations} />
        <Group label="Operations & Customer Success" people={customerSuccess} />
        <Group label="Advisory" people={advisory} />
      </div>

      <p className="mt-10 text-sm text-muted-foreground italic font-display text-xl max-w-3xl">
        Specialist compliance capacity is delivered through our CompliSun partnership — meet that team a few slides on.
      </p>
    </SlideFrame>
  );
}
